import { ButtonBase, styled } from "@mui/material";
import React from "react";

const HyroOption = ({ name, Icon, iconPosition = "left", selected, onClick, disabled = false }) => (
  <StyledButtonBase
    data-testid={`hyro-option-${name}`}
    selected={selected}
    aria-pressed={Boolean(selected)}
    aria-disabled={Boolean(disabled)}
    onClick={onClick}
    disabled={disabled}
  >
    {Icon && iconPosition === "left" && <Icon />}
    {name}
    {Icon && iconPosition === "right" && <Icon />}
  </StyledButtonBase>
);

const StyledButtonBase = styled(ButtonBase)(({ theme, selected }) => ({
  border: selected ? `2px solid ${theme.palette.secondary[500]}` : "1px solid rgba(45, 44, 68, 0.24)",
  borderRadius: theme.shape.borderRadius,
  fontFamily: "inter, sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  width: "240px",
  height: "48px",
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  color: selected ? theme.palette.primary[500] : theme.palette.text[800],
  "& svg path": {
    stroke: "currentcolor"
  },
  "&:hover": {
    backgroundColor: theme.palette.tertiary[100],
    border: selected ? `2px solid ${theme.palette.secondary[500]}` : "1px solid rgba(45, 44, 68, 0.24)",
    color: theme.palette.primary[500]
  },
  "&:disabled": {
    color: theme.palette.system[600]
  }
}));

export default HyroOption;
